// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__TCySm","links":"NavBar_links__3x2ku","link":"NavBar_link__OYl6D","current":"NavBar_current__NgbQa"};